module.exports = __webpack_public_path__ + "static/media/pg_sample_left_beaker_full.29e0c6ca.svg";